import React, { useState } from "react";
import { X, Save, Edit2, Trash2, MessageSquare } from "lucide-react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./app.css";
import { secretKey } from "./data";

const MySwal = withReactContent(Swal2);
const API = "https://apiftpsplit.ftpeople.pl";
const hdrs = { "Content-Type": "application/json", Authorization: secretKey };

const todayStr = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
    2,
    "0"
  )}-${String(d.getDate()).padStart(2, "0")}`;
};

const AddContact = (props) => {
  const isEdit = props.mode === "edit";
  const isList = props.mode === "list";
  const canEdit =
    isEdit &&
    (+props.contact?.user === +props.user.id || props.user.role === "admin");

  const [content, setContent] = useState(isEdit ? props.contact.content : "");
  const [editing, setEditing] = useState(!isEdit);

  const validate = () => {
    if (!content.trim()) {
      MySwal.fire({
        icon: "error",
        title: "Wypełnij",
        text: "wymagane pola formularza",
      });
      return false;
    }
    return true;
  };

  const handleAdd = async () => {
    if (!validate()) return;
    try {
      await fetch(`${API}/addContact`, {
        method: "POST",
        headers: hdrs,
        body: JSON.stringify({
          content,
          user: props.user.id,
          userId: props.user.id,
          userName: props.user.name,
          id: isList ? props.leadId : props.lead.id,
        }),
      });
      MySwal.fire({ icon: "success", title: "Kontakt", text: "dodany" });

      if (isList) {
        await fetch(`${API}/editLead`, {
          method: "POST",
          headers: hdrs,
          body: JSON.stringify({
            id: props.leadId,
            field: "lastTalkDate",
            value: todayStr(),
            userId: props.user.id,
            userName: props.user.name,
          }),
        });
      }
      props.close();
    } catch (err) {
      console.error(err);
    }
  };

  const handleEdit = async () => {
    if (!validate()) return;
    try {
      await fetch(`${API}/editContact`, {
        method: "POST",
        headers: hdrs,
        body: JSON.stringify({
          id: props.contact.id,
          content,
          userId: props.user.id,
          userName: props.user.name,
        }),
      });
      MySwal.fire({ icon: "success", title: "Kontakt", text: "zmieniony" });
      props.close();
    } catch (err) {
      console.error(err);
    }
  };

  const handleDelete = async () => {
    try {
      await fetch(`${API}/deleteContact`, {
        method: "POST",
        headers: hdrs,
        body: JSON.stringify({ id: props.contact.id }),
      });
      MySwal.fire({ icon: "success", title: "Kontakt", text: "usunięty" });
      props.close();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div
      className="sn-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) props.close();
      }}
    >
      <div className="sn-modal" style={{ maxWidth: 560 }}>
        {/* Header */}
        <div className="sn-header">
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <MessageSquare size={18} />
            <div>
              <h2 className="sn-title">
                {editing
                  ? isEdit
                    ? "Edytuj kontakt"
                    : "Dodaj kontakt"
                  : "Kontakt"}
              </h2>
              <span className="sn-subtitle">Użytkownik: {props.user.name}</span>
            </div>
          </div>
          <button className="ld-close" onClick={props.close}>
            <X size={18} />
          </button>
        </div>

        {/* Body */}
        <div className="sn-body">
          <div className="rp-field">
            <label className="db-field-label">
              Notatka <span className="scc-req">*</span>
            </label>
            <textarea
              className="db-input ac-textarea"
              disabled={!editing}
              value={content}
              onChange={(e) => setContent(e.target.value)}
              placeholder="Treść notatki kontaktowej..."
            />
          </div>

          <div className="scc-form-footer">
            {editing && (
              <button
                className="lq-btn lq-btn--success"
                onClick={isEdit ? handleEdit : handleAdd}
              >
                <Save size={14} /> {isEdit ? "Zapisz" : "Dodaj"}
              </button>
            )}

            {canEdit && !editing && (
              <button
                className="lq-btn lq-btn--primary"
                onClick={() => setEditing(true)}
              >
                <Edit2 size={14} /> Edytuj
              </button>
            )}

            {canEdit && editing && isEdit && (
              <button
                className="lq-btn lq-btn--muted"
                onClick={() => {
                  setEditing(false);
                  setContent(props.contact.content);
                }}
              >
                Anuluj edycję
              </button>
            )}

            {canEdit && (
              <button className="lq-btn lq-btn--danger" onClick={handleDelete}>
                <Trash2 size={14} /> Usuń
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddContact;
